module.exports = __webpack_public_path__ + "static/media/asthme.72d97207.png";